webpackJsonp([1],{

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Content__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Content__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/', redirect: '/osiris/inicio'
  }, {
    path: '/osiris', redirect: '/osiris/inicio'
  }, {
    path: '/osiris/:pagina',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Content___default.a
  }]
}));

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __cov_0GTwwl$GMPTkkuRWFDyc4w = (Function('return this'))();
if (!__cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__) { __cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__ = {}; }
__cov_0GTwwl$GMPTkkuRWFDyc4w = __cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__;
if (!(__cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'])) {
   __cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'] = {"path":"/home/fahrenq/code/v-img/lib/ImgScreen.vue","s":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0},"b":{"1":[0,0],"2":[0,0],"3":[0,0],"4":[0,0],"5":[0,0],"6":[0,0],"7":[0,0],"8":[0,0],"9":[0,0],"10":[0,0],"11":[0,0],"12":[0,0],"13":[0,0],"14":[0,0],"15":[0,0],"16":[0,0],"17":[0,0],"18":[0,0],"19":[0,0]},"f":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0},"fnMap":{"1":{"name":"(anonymous_1)","line":1,"loc":{"start":{"line":1,"column":1},"end":{"line":1,"column":13}}},"2":{"name":"render","line":13,"loc":{"start":{"line":13,"column":25},"end":{"line":13,"column":43}}},"3":{"name":"click","line":14,"loc":{"start":{"line":14,"column":225},"end":{"line":14,"column":248}}},"4":{"name":"data","line":20,"loc":{"start":{"line":20,"column":8},"end":{"line":20,"column":24}}},"5":{"name":"close","line":31,"loc":{"start":{"line":31,"column":11},"end":{"line":31,"column":28}}},"6":{"name":"next","line":37,"loc":{"start":{"line":37,"column":10},"end":{"line":37,"column":26}}},"7":{"name":"prev","line":45,"loc":{"start":{"line":45,"column":10},"end":{"line":45,"column":26}}},"8":{"name":"showUI","line":53,"loc":{"start":{"line":53,"column":12},"end":{"line":53,"column":30}}},"9":{"name":"(anonymous_9)","line":60,"loc":{"start":{"line":60,"column":34},"end":{"line":60,"column":46}}},"10":{"name":"created","line":65,"loc":{"start":{"line":65,"column":11},"end":{"line":65,"column":30}}},"11":{"name":"(anonymous_11)","line":68,"loc":{"start":{"line":68,"column":37},"end":{"line":68,"column":50}}},"12":{"name":"(anonymous_12)","line":76,"loc":{"start":{"line":76,"column":38},"end":{"line":76,"column":50}}},"13":{"name":"(anonymous_13)","line":79,"loc":{"start":{"line":79,"column":41},"end":{"line":79,"column":53}}}},"statementMap":{"1":{"start":{"line":1,"column":0},"end":{"line":11,"column":5}},"2":{"start":{"line":2,"column":2},"end":{"line":10,"column":3}},"3":{"start":{"line":3,"column":4},"end":{"line":5,"column":2130}},"4":{"start":{"line":5,"column":2130},"end":{"line":5,"column":2154}},"5":{"start":{"line":5,"column":2154},"end":{"line":9,"column":5}},"6":{"start":{"line":6,"column":6},"end":{"line":6,"column":37}},"7":{"start":{"line":8,"column":6},"end":{"line":8,"column":54}},"8":{"start":{"line":9,"column":5},"end":{"line":9,"column":29}},"9":{"start":{"line":14,"column":4},"end":{"line":14,"column":19}},"10":{"start":{"line":14,"column":19},"end":{"line":14,"column":47}},"11":{"start":{"line":14,"column":47},"end":{"line":14,"column":75}},"12":{"start":{"line":14,"column":75},"end":{"line":18,"column":1683}},"13":{"start":{"line":15,"column":10},"end":{"line":17,"column":11}},"14":{"start":{"line":16,"column":12},"end":{"line":16,"column":24}},"15":{"start":{"line":17,"column":11},"end":{"line":17,"column":23}},"16":{"start":{"line":21,"column":4},"end":{"line":27,"column":6}},"17":{"start":{"line":32,"column":6},"end":{"line":32,"column":71}},"18":{"start":{"line":33,"column":6},"end":{"line":33,"column":23}},"19":{"start":{"line":34,"column":6},"end":{"line":34,"column":33}},"20":{"start":{"line":35,"column":6},"end":{"line":35,"column":25}},"21":{"start":{"line":39,"column":6},"end":{"line":43,"column":7}},"22":{"start":{"line":40,"column":8},"end":{"line":40,"column":33}},"23":{"start":{"line":42,"column":8},"end":{"line":42,"column":35}},"24":{"start":{"line":47,"column":6},"end":{"line":51,"column":7}},"25":{"start":{"line":48,"column":8},"end":{"line":48,"column":33}},"26":{"start":{"line":50,"column":8},"end":{"line":50,"column":56}},"27":{"start":{"line":54,"column":6},"end":{"line":54,"column":23}},"28":{"start":{"line":58,"column":6},"end":{"line":58,"column":35}},"29":{"start":{"line":59,"column":6},"end":{"line":59,"column":28}},"30":{"start":{"line":60,"column":6},"end":{"line":62,"column":15}},"31":{"start":{"line":61,"column":8},"end":{"line":61,"column":32}},"32":{"start":{"line":66,"column":4},"end":{"line":66,"column":22}},"33":{"start":{"line":68,"column":4},"end":{"line":75,"column":7}},"34":{"start":{"line":70,"column":6},"end":{"line":70,"column":63}},"35":{"start":{"line":70,"column":48},"end":{"line":70,"column":63}},"36":{"start":{"line":72,"column":6},"end":{"line":72,"column":62}},"37":{"start":{"line":72,"column":48},"end":{"line":72,"column":62}},"38":{"start":{"line":74,"column":6},"end":{"line":74,"column":62}},"39":{"start":{"line":74,"column":48},"end":{"line":74,"column":62}},"40":{"start":{"line":76,"column":4},"end":{"line":78,"column":7}},"41":{"start":{"line":77,"column":6},"end":{"line":77,"column":21}},"42":{"start":{"line":79,"column":4},"end":{"line":81,"column":7}},"43":{"start":{"line":80,"column":6},"end":{"line":80,"column":22}}},"branchMap":{"1":{"line":2,"type":"if","locations":[{"start":{"line":2,"column":2},"end":{"line":2,"column":2}},{"start":{"line":2,"column":2},"end":{"line":2,"column":2}}]},"2":{"line":3,"type":"binary-expr","locations":[{"start":{"line":3,"column":15},"end":{"line":3,"column":28}},{"start":{"line":3,"column":32},"end":{"line":3,"column":72}}]},"3":{"line":5,"type":"if","locations":[{"start":{"line":5,"column":2154},"end":{"line":5,"column":2154}},{"start":{"line":5,"column":2154},"end":{"line":5,"column":2154}}]},"4":{"line":14,"type":"binary-expr","locations":[{"start":{"line":14,"column":56},"end":{"line":14,"column":68}},{"start":{"line":14,"column":72},"end":{"line":14,"column":74}}]},"5":{"line":14,"type":"cond-expr","locations":[{"start":{"line":14,"column":165},"end":{"line":18,"column":1669}},{"start":{"line":18,"column":1672},"end":{"line":18,"column":1680}}]},"6":{"line":15,"type":"if","locations":[{"start":{"line":15,"column":10},"end":{"line":15,"column":10}},{"start":{"line":15,"column":10},"end":{"line":15,"column":10}}]},"7":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":84},"end":{"line":18,"column":211}},{"start":{"line":18,"column":214},"end":{"line":18,"column":222}}]},"8":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":425},"end":{"line":18,"column":903}},{"start":{"line":18,"column":906},"end":{"line":18,"column":914}}]},"9":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":382},"end":{"line":18,"column":395}},{"start":{"line":18,"column":399},"end":{"line":18,"column":422}}]},"10":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":1030},"end":{"line":18,"column":1509}},{"start":{"line":18,"column":1512},"end":{"line":18,"column":1520}}]},"11":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":987},"end":{"line":18,"column":1000}},{"start":{"line":18,"column":1004},"end":{"line":18,"column":1027}}]},"12":{"line":39,"type":"if","locations":[{"start":{"line":39,"column":6},"end":{"line":39,"column":6}},{"start":{"line":39,"column":6},"end":{"line":39,"column":6}}]},"13":{"line":47,"type":"if","locations":[{"start":{"line":47,"column":6},"end":{"line":47,"column":6}},{"start":{"line":47,"column":6},"end":{"line":47,"column":6}}]},"14":{"line":70,"type":"if","locations":[{"start":{"line":70,"column":6},"end":{"line":70,"column":6}},{"start":{"line":70,"column":6},"end":{"line":70,"column":6}}]},"15":{"line":70,"type":"binary-expr","locations":[{"start":{"line":70,"column":10},"end":{"line":70,"column":26}},{"start":{"line":70,"column":30},"end":{"line":70,"column":46}}]},"16":{"line":72,"type":"if","locations":[{"start":{"line":72,"column":6},"end":{"line":72,"column":6}},{"start":{"line":72,"column":6},"end":{"line":72,"column":6}}]},"17":{"line":72,"type":"binary-expr","locations":[{"start":{"line":72,"column":10},"end":{"line":72,"column":26}},{"start":{"line":72,"column":30},"end":{"line":72,"column":46}}]},"18":{"line":74,"type":"if","locations":[{"start":{"line":74,"column":6},"end":{"line":74,"column":6}},{"start":{"line":74,"column":6},"end":{"line":74,"column":6}}]},"19":{"line":74,"type":"binary-expr","locations":[{"start":{"line":74,"column":10},"end":{"line":74,"column":26}},{"start":{"line":74,"column":30},"end":{"line":74,"column":46}}]}}};
}
__cov_0GTwwl$GMPTkkuRWFDyc4w = __cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'];
__cov_0GTwwl$GMPTkkuRWFDyc4w.s['1']++;(function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['1']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['2']++;if(document){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['1'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['3']++;var head=(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['2'][0]++,document.head)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['2'][1]++,document.getElementsByTagName('head')[0]),style=document.createElement('style'),css=' *[data-v-5928e1c7] { -webkit-box-sizing: border-box; box-sizing: border-box; } .fullscreen-v-img[data-v-5928e1c7] { height: 100%; width: 100%; position: fixed; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, .7); -ms-touch-action: none; touch-action: none; } .content-v-img img[data-v-5928e1c7] { width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .header-v-img[data-v-5928e1c7] { position: absolute; width: 100%; background-color: rgba(0, 0, 0, .3); height: 50px; z-index: 9999; } .count-v-img[data-v-5928e1c7] { font-family: \'Avenir\', Helvetica, Arial, sans-serif; font-size: 15px; color: white; margin-left: 10px; line-height: 50px; } .close-v-img[data-v-5928e1c7] { float: right; margin-right: 10px; font-family: \'Avenir\', Helvetica, Arial, sans-serif; color: #E5E6EB; font-size: 30px; line-height: 50px; cursor: pointer; -webkit-transition: color .4s ease-in-out; transition: color .4s ease-in-out; } .close-v-img[data-v-5928e1c7]:hover { color: white; } .prev-v-img svg[data-v-5928e1c7], .next-v-img svg[data-v-5928e1c7] { margin: 5px auto; } .prev-v-img[data-v-5928e1c7], .next-v-img[data-v-5928e1c7] { color: white; width: 35px; height: 35px; position: absolute; top: 50%; margin-top: -12.5px; font-size: 15px; font-family: \'Avenir\', Helvetica, Arial, sans-serif; text-align: center; background-color: rgba(0, 0, 0, .3); z-index: 1000; opacity: .3; -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; cursor: pointer; } .prev-v-img[data-v-5928e1c7]:hover, .next-v-img[data-v-5928e1c7]:hover { opacity: 1; } .prev-v-img[data-v-5928e1c7] { left: 10px; } .next-v-img[data-v-5928e1c7] { right: 10px; } .v-img-fade-enter[data-v-5928e1c7], .v-img-fade-leave-to[data-v-5928e1c7] { opacity: 0; } .v-img-fade-enter-active[data-v-5928e1c7], .v-img-fade-leave-active[data-v-5928e1c7] { -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; } .body-fs-v-img {} ';__cov_0GTwwl$GMPTkkuRWFDyc4w.s['4']++;style.type='text/css';__cov_0GTwwl$GMPTkkuRWFDyc4w.s['5']++;if(style.styleSheet){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['3'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['6']++;style.styleSheet.cssText=css;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['3'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['7']++;style.appendChild(document.createTextNode(css));}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['8']++;head.appendChild(style);}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['1'][1]++;}}());var ImgScreen = {render:function render(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['2']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['9']++;var _vm=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['10']++;var _h=_vm.$createElement;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['11']++;var _c=(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['4'][0]++,_vm._self._c)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['4'][1]++,_h);__cov_0GTwwl$GMPTkkuRWFDyc4w.s['12']++;return _c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[!_vm.closed?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['5'][0]++,_c('div',{staticClass:'fullscreen-v-img',on:{'click':function click($event){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['3']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['13']++;if($event.target!==$event.currentTarget){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['6'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['14']++;return null;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['6'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['15']++;_vm.close();}}},[_c('div',{staticClass:'header-v-img'},[_vm.images.length>1?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['7'][0]++,_c('span',{staticClass:'count-v-img'},[_vm._v(_vm._s(_vm.currentImageIndex+1)+'/'+_vm._s(_vm.images.length)+' ')])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['7'][1]++,_vm._e()),_c('span',{staticClass:'close-v-img',on:{'click':_vm.close}},[_vm._v('\xD7')])]),_c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['9'][0]++,_vm.visibleUI)&&(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['9'][1]++,_vm.images.length!==1)?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['8'][0]++,_c('span',{staticClass:'prev-v-img',on:{'click':_vm.prev}},[_c('svg',{attrs:{'width':'25','height':'25','viewBox':'0 0 1792 1915','xmlns':'http://www.w3.org/2000/svg'}},[_c('path',{attrs:{'d':'M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z','fill':'#fff'}})])])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['8'][1]++,_vm._e())]),_c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['11'][0]++,_vm.visibleUI)&&(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['11'][1]++,_vm.images.length!==1)?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['10'][0]++,_c('span',{staticClass:'next-v-img',on:{'click':_vm.next}},[_c('svg',{attrs:{'width':'25','height':'25','viewBox':'0 0 1792 1915','xmlns':'http://www.w3.org/2000/svg'}},[_c('path',{attrs:{'d':'M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z','fill':'#fff'}})])])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['10'][1]++,_vm._e())]),_c('div',{staticClass:'content-v-img'},[_c('img',{attrs:{'src':_vm.images[_vm.currentImageIndex]},on:{'click':_vm.next}})])],1)):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['5'][1]++,_vm._e())]);},staticRenderFns:[],_scopeId:'data-v-5928e1c7',data:function data(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['4']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['16']++;return{images:[],visibleUI:true,currentImageIndex:0,closed:true,uiTimeout:null};},methods:{close:function close(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['5']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['17']++;document.querySelector('body').classList.remove('body-fs-v-img');__cov_0GTwwl$GMPTkkuRWFDyc4w.s['18']++;this.images=[];__cov_0GTwwl$GMPTkkuRWFDyc4w.s['19']++;this.currentImageIndex=0;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['20']++;this.closed=true;},next:function next(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['6']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['21']++;if(this.currentImageIndex+1<this.images.length){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['12'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['22']++;this.currentImageIndex++;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['12'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['23']++;this.currentImageIndex=0;}},prev:function prev(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['7']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['24']++;if(this.currentImageIndex>0){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['13'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['25']++;this.currentImageIndex--;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['13'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['26']++;this.currentImageIndex=this.images.length-1;}},showUI:function showUI(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['8']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['27']++;var _this=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['28']++;clearTimeout(this.uiTimeout);__cov_0GTwwl$GMPTkkuRWFDyc4w.s['29']++;this.visibleUI=true;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['30']++;this.uiTimeout=setTimeout(function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['9']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['31']++;_this.visibleUI=false;},3500);}},created:function created(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['10']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['32']++;var _this2=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['33']++;window.addEventListener('keyup',function(e){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['11']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['34']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['15'][0]++,e.keyCode===27)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['15'][1]++,e.keyCode===81)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['14'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['35']++;_this2.close();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['14'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['36']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['17'][0]++,e.keyCode===39)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['17'][1]++,e.keyCode===76)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['16'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['37']++;_this2.next();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['16'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['38']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['19'][0]++,e.keyCode===37)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['19'][1]++,e.keyCode===72)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['18'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['39']++;_this2.prev();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['18'][1]++;}});__cov_0GTwwl$GMPTkkuRWFDyc4w.s['40']++;window.addEventListener('scroll',function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['12']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['41']++;_this2.close();});__cov_0GTwwl$GMPTkkuRWFDyc4w.s['42']++;window.addEventListener('mousemove',function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['13']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['43']++;_this2.showUI();});}};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var __cov_WuSw60ZQZcI1aW7neh6dWA = (Function('return this'))();
if (!__cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__) { __cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__ = {}; }
__cov_WuSw60ZQZcI1aW7neh6dWA = __cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__;
if (!(__cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'])) {
   __cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'] = {"path":"/home/fahrenq/code/v-img/lib/index.js","s":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0},"b":{"1":[0,0],"2":[0,0],"3":[0,0],"4":[0,0],"5":[0,0],"6":[0,0],"7":[0,0],"8":[0,0],"9":[0,0],"10":[0,0],"11":[0,0],"12":[0,0]},"f":{"1":0,"2":0,"3":0,"4":0},"fnMap":{"1":{"name":"install","line":6,"loc":{"start":{"line":6,"column":14},"end":{"line":6,"column":36}}},"2":{"name":"bind","line":10,"loc":{"start":{"line":10,"column":10},"end":{"line":10,"column":37}}},"3":{"name":"(anonymous_3)","line":45,"loc":{"start":{"line":45,"column":35},"end":{"line":45,"column":47}}},"4":{"name":"(anonymous_4)","line":52,"loc":{"start":{"line":52,"column":43},"end":{"line":52,"column":56}}}},"statementMap":{"1":{"start":{"line":6,"column":0},"end":{"line":61,"column":2}},"2":{"start":{"line":7,"column":2},"end":{"line":7,"column":37}},"3":{"start":{"line":9,"column":2},"end":{"line":60,"column":5}},"4":{"start":{"line":12,"column":6},"end":{"line":12,"column":29}},"5":{"start":{"line":13,"column":6},"end":{"line":13,"column":23}},"6":{"start":{"line":14,"column":6},"end":{"line":14,"column":38}},"7":{"start":{"line":17,"column":6},"end":{"line":21,"column":7}},"8":{"start":{"line":18,"column":8},"end":{"line":18,"column":48}},"9":{"start":{"line":19,"column":8},"end":{"line":19,"column":39}},"10":{"start":{"line":20,"column":8},"end":{"line":20,"column":45}},"11":{"start":{"line":24,"column":6},"end":{"line":24,"column":59}},"12":{"start":{"line":25,"column":6},"end":{"line":27,"column":7}},"13":{"start":{"line":26,"column":8},"end":{"line":26,"column":63}},"14":{"start":{"line":29,"column":6},"end":{"line":29,"column":70}},"15":{"start":{"line":29,"column":16},"end":{"line":29,"column":70}},"16":{"start":{"line":32,"column":6},"end":{"line":32,"column":31}},"17":{"start":{"line":35,"column":6},"end":{"line":35,"column":29}},"18":{"start":{"line":36,"column":6},"end":{"line":41,"column":7}},"19":{"start":{"line":37,"column":8},"end":{"line":37,"column":52}},"20":{"start":{"line":38,"column":8},"end":{"line":38,"column":50}},"21":{"start":{"line":39,"column":8},"end":{"line":39,"column":60}},"22":{"start":{"line":40,"column":8},"end":{"line":40,"column":65}},"23":{"start":{"line":45,"column":6},"end":{"line":58,"column":9}},"24":{"start":{"line":46,"column":8},"end":{"line":46,"column":70}},"25":{"start":{"line":48,"column":8},"end":{"line":48,"column":133}},"26":{"start":{"line":49,"column":8},"end":{"line":56,"column":9}},"27":{"start":{"line":50,"column":10},"end":{"line":50,"column":39}},"28":{"start":{"line":52,"column":10},"end":{"line":54,"column":14}},"29":{"start":{"line":53,"column":12},"end":{"line":53,"column":48}},"30":{"start":{"line":55,"column":10},"end":{"line":55,"column":63}},"31":{"start":{"line":57,"column":8},"end":{"line":57,"column":37}}},"branchMap":{"1":{"line":14,"type":"binary-expr","locations":[{"start":{"line":14,"column":18},"end":{"line":14,"column":29}},{"start":{"line":14,"column":33},"end":{"line":14,"column":37}}]},"2":{"line":17,"type":"if","locations":[{"start":{"line":17,"column":6},"end":{"line":17,"column":6}},{"start":{"line":17,"column":6},"end":{"line":17,"column":6}}]},"3":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":17},"end":{"line":18,"column":37}},{"start":{"line":18,"column":41},"end":{"line":18,"column":47}}]},"4":{"line":19,"type":"binary-expr","locations":[{"start":{"line":19,"column":14},"end":{"line":19,"column":31}},{"start":{"line":19,"column":35},"end":{"line":19,"column":38}}]},"5":{"line":20,"type":"binary-expr","locations":[{"start":{"line":20,"column":16},"end":{"line":20,"column":35}},{"start":{"line":20,"column":39},"end":{"line":20,"column":44}}]},"6":{"line":24,"type":"binary-expr","locations":[{"start":{"line":24,"column":44},"end":{"line":24,"column":49}},{"start":{"line":24,"column":53},"end":{"line":24,"column":57}}]},"7":{"line":25,"type":"if","locations":[{"start":{"line":25,"column":6},"end":{"line":25,"column":6}},{"start":{"line":25,"column":6},"end":{"line":25,"column":6}}]},"8":{"line":25,"type":"binary-expr","locations":[{"start":{"line":25,"column":10},"end":{"line":25,"column":23}},{"start":{"line":25,"column":27},"end":{"line":25,"column":44}}]},"9":{"line":29,"type":"if","locations":[{"start":{"line":29,"column":6},"end":{"line":29,"column":6}},{"start":{"line":29,"column":6},"end":{"line":29,"column":6}}]},"10":{"line":36,"type":"if","locations":[{"start":{"line":36,"column":6},"end":{"line":36,"column":6}},{"start":{"line":36,"column":6},"end":{"line":36,"column":6}}]},"11":{"line":49,"type":"if","locations":[{"start":{"line":49,"column":8},"end":{"line":49,"column":8}},{"start":{"line":49,"column":8},"end":{"line":49,"column":8}}]},"12":{"line":53,"type":"binary-expr","locations":[{"start":{"line":53,"column":19},"end":{"line":53,"column":38}},{"start":{"line":53,"column":42},"end":{"line":53,"column":47}}]}}};
}
__cov_WuSw60ZQZcI1aW7neh6dWA = __cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'];
__cov_WuSw60ZQZcI1aW7neh6dWA.s['1']++;var install=function install(Vue){__cov_WuSw60ZQZcI1aW7neh6dWA.f['1']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['2']++;var screen=Vue.extend(ImgScreen);__cov_WuSw60ZQZcI1aW7neh6dWA.s['3']++;Vue.directive('img',{bind:function bind(el,binding){__cov_WuSw60ZQZcI1aW7neh6dWA.f['2']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['4']++;var cursor='pointer';__cov_WuSw60ZQZcI1aW7neh6dWA.s['5']++;var src=el.src;__cov_WuSw60ZQZcI1aW7neh6dWA.s['6']++;var group=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['1'][0]++,binding.arg)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['1'][1]++,null);__cov_WuSw60ZQZcI1aW7neh6dWA.s['7']++;if(typeof binding.value!=='undefined'){__cov_WuSw60ZQZcI1aW7neh6dWA.b['2'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['8']++;cursor=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['3'][0]++,binding.value.cursor)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['3'][1]++,cursor);__cov_WuSw60ZQZcI1aW7neh6dWA.s['9']++;src=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['4'][0]++,binding.value.src)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['4'][1]++,src);__cov_WuSw60ZQZcI1aW7neh6dWA.s['10']++;group=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['5'][0]++,binding.value.group)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['5'][1]++,group);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['2'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['11']++;el.setAttribute('data-vue-img-group',(__cov_WuSw60ZQZcI1aW7neh6dWA.b['6'][0]++,group)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['6'][1]++,null));__cov_WuSw60ZQZcI1aW7neh6dWA.s['12']++;if((__cov_WuSw60ZQZcI1aW7neh6dWA.b['8'][0]++,binding.value)&&(__cov_WuSw60ZQZcI1aW7neh6dWA.b['8'][1]++,binding.value.src)){__cov_WuSw60ZQZcI1aW7neh6dWA.b['7'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['13']++;el.setAttribute('data-vue-img-src',binding.value.src);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['7'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['14']++;if(!src){__cov_WuSw60ZQZcI1aW7neh6dWA.b['9'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['15']++;console.error('v-img element missing src parameter.');}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['9'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['16']++;el.style.cursor=cursor;__cov_WuSw60ZQZcI1aW7neh6dWA.s['17']++;var vm=window.vueImg;__cov_WuSw60ZQZcI1aW7neh6dWA.s['18']++;if(!vm){__cov_WuSw60ZQZcI1aW7neh6dWA.b['10'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['19']++;var element=document.createElement('div');__cov_WuSw60ZQZcI1aW7neh6dWA.s['20']++;element.setAttribute('id','imageScreen');__cov_WuSw60ZQZcI1aW7neh6dWA.s['21']++;document.querySelector('body').appendChild(element);__cov_WuSw60ZQZcI1aW7neh6dWA.s['22']++;vm=window.vueImg=new screen().$mount('#imageScreen');}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['10'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['23']++;el.addEventListener('click',function(){__cov_WuSw60ZQZcI1aW7neh6dWA.f['3']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['24']++;document.querySelector('body').classList.add('body-fs-v-img');__cov_WuSw60ZQZcI1aW7neh6dWA.s['25']++;var images=[].concat(toConsumableArray(document.querySelectorAll('img[data-vue-img-group="'+group+'"]')));__cov_WuSw60ZQZcI1aW7neh6dWA.s['26']++;if(images.length==0){__cov_WuSw60ZQZcI1aW7neh6dWA.b['11'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['27']++;Vue.set(vm,'images',[src]);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['11'][1]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['28']++;Vue.set(vm,'images',images.map(function(e){__cov_WuSw60ZQZcI1aW7neh6dWA.f['4']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['29']++;return(__cov_WuSw60ZQZcI1aW7neh6dWA.b['12'][0]++,e.dataset.vueImgSrc)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['12'][1]++,e.src);}));__cov_WuSw60ZQZcI1aW7neh6dWA.s['30']++;Vue.set(vm,'currentImageIndex',images.indexOf(el));}__cov_WuSw60ZQZcI1aW7neh6dWA.s['31']++;Vue.set(vm,'closed',false);});}});};

/* harmony default export */ __webpack_exports__["a"] = (install);
//# sourceMappingURL=v-img.mjs.map


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(80),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_img__ = __webpack_require__(26);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_v_img__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      content: '',
      reliefWeb: [],
      hResponse: [],
      sigimera: []
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.reliefweb.int/v1/disasters?appname=apidoc&limit=10').then(function (response) {
      _this.reliefWeb = response.data.data;
    }).catch(function (error) {
      console.log(error.data.error.message);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.humanitarianresponse.info/api/v1.0/disasters?filter[status]=current').then(function (response) {
      _this.hResponse = response.data.data;
    }).catch(function (error) {
      console.log(error.data.error.message);
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-sigimera').then(function (response) {
      _this.sigimera = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_carousel__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content',
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Slide"]
  },
  data: function data() {
    return {
      menu: '',
      secondary_menu: '',
      content: '',
      legislacao: false,
      imgs: [],
      prjs: [],
      prj: null,
      photosets: [],
      galeriaDestaques: []
    };
  },

  computed: {
    projects: function projects() {
      if (this.prjs.length === 0) {
        return null;
      }
      var res = this.prjs.reduce(function (r, a) {
        r[a.ano_conclusao] = r[a.ano_conclusao] || [];
        r[a.ano_conclusao].push(a);
        return r;
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null));

      var res2 = [];

      for (var key in res) {
        res2.push({
          key: key,
          value: res[key]
        });
      }

      var prjs = res2.slice(1).reverse();
      prjs.unshift(res2[0]);

      return prjs;
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-menu').then(function (response) {
      _this.menu = response.data;
    }).catch(function (error) {
      console.log(error.data.error.message);
    });

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-galeria-destaques').then(function (response) {
      _this.galeriaDestaques = response.data;
    }).catch(function (error) {
      console.log(error.data.error.message);
    });

    this.mainContent();
    this.submenu();
  },
  beforeUpdate: function beforeUpdate() {
    // this.mainContent()
    this.submenu();
  },

  // watch: {
  //   prjs: function (pjs) {
  //     let res = pjs.reduce(function (r, a) {
  //       r[a.ano_conclusao] = r[a.ano_conclusao] || []
  //       r[a.ano_conclusao].push(a)
  //       return r
  //     }, Object.create(null))

  //     console.log(Object.keys(res))
  //   }
  // },
  methods: {
    mainContent: function mainContent() {
      var _this2 = this;

      if (this.$route.params.pagina === 'projectos' || this.$route.params.pagina === 'investigacao-e-parcerias') {
        // projectos
        var prj = 0;
        if (this.$route.query.prj !== undefined) {
          prj = this.$route.query.prj;
        }
        this.legislacao = false;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-projects/osiris?prj=' + prj).then(function (response) {
          if (prj === 0) {
            _this2.prjs = response.data;
          } else {
            _this2.prj = response.data;
          }
          // this.content = response.data
        }).catch(function (error) {
          console.log(error.data.error.message);
        });
      } else if (this.$route.params.pagina === 'eventos' || this.$route.params.pagina === 'agenda') {
        // agenda
        this.legislacao = false;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-eventos/osiris').then(function (response) {
          _this2.content = response.data;
        }).catch(function (error) {
          console.log(error.data.error.message);
        });
      } else if (this.$route.params.pagina === 'sala-de-imprensa' || this.$route.params.pagina === 'noticias') {
        // noticias
        this.legislacao = false;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-noticias/osiris').then(function (response) {
          _this2.content = { 'title': 'Notícias', 'content': response.data };
        }).catch(function (error) {
          console.log(error.data.error.message);
        });
      } else if (this.$route.params.pagina === 'portfolio-2017' || this.$route.params.pagina === 'portfolio') {
        // galeria
        this.legislacao = false;
        if (this.imgs.length === 0) {
          // axios.get('https://api.flickr.com/services/rest/?method=flickr.photosets.getList&api_key=5a189299a32c16443568e66b74cd9caf&user_id=157816548%40N08&format=json&auth_token=72157662995982778-945066a6d8bc3c9e&api_sig=e5a6620a7ec1e8278ec09e75c28bb482')
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.flickr.com/services/rest/?method=flickr.photosets.getList&primary_photo_extras&phot_ids&api_key=e94097a3a156c29a58a5a89cb82bac0c&user_id=157816548%40N08&format=json&nojsoncallback=?').then(function (response) {
            console.log(response);
            _this2.photosets = response.data.photosets.photoset;
          }).catch(function (error) {
            console.log(error);
          });
        }
      } else if (this.$route.params.pagina === 'opiniao') {
        // opinião
        this.legislacao = false;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-opiniao/osiris').then(function (response) {
          _this2.content = { 'title': 'Opinião', 'content': response.data };
        }).catch(function (error) {
          console.log(error.data.error.message);
        });
      } else if (this.$route.params.pagina === 'recursos' || this.$route.params.pagina === 'legislacao') {
        // legislação
        this.legislacao = true;
        // })
      } else {
        this.legislacao = false;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://www.ces.uc.pt/osiris/site/api2.php/17643/1/get-content/' + this.$route.params.pagina) // conteúdo genérico
        .then(function (response) {
          _this2.content = response.data;
          _this2.imgs = response.data.galeria;
        }).catch(function (error) {
          console.log(error.data.error.message);
        });
      }
    },
    submenu: function submenu() {
      var _this3 = this;

      if (this.$route.params.pagina !== 'inicio') {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://www.ces.uc.pt/osiris/site/api2.php/' + this.$route.params.pagina + '/1/get-menu').then(function (response) {
          _this3.secondary_menu = response.data;
          console.log(_this3.secondary_menu);
          var menus = document.querySelectorAll('ul.nav li a');
          for (var i = 0; i < menus.length; ++i) {
            var menu = menus[i].href.substring(menus[i].href.lastIndexOf('/') + 1, menus[i].href.length);
            if (menu === _this3.$route.params.pagina || menu === _this3.content.item_menu) {
              menus[i].parentElement.classList.add('current');
            }
          }
        }).catch(function (error) {
          console.log(error.data.error.message);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://www.ces.uc.pt/osiris/site/api.php/' + this.$route.params.pagina + '/1/get-destaques').then(function (response) {
          _this3.secondary_menu = response.data;
        }).catch(function (error) {
          console.log(error.data.error.message);
        });
      }
    }
  }
});

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var Component = __webpack_require__(24)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(79),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 79:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "leftbar col-xs-12 col-sm-12 col-md-3 col-lg-3"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.menu)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twitter-timeline",
    attrs: {
      "data-height": "600",
      "href": "https://twitter.com/OSIRIS_CES?ref_src=twsrc%5Etfw"
    }
  }, [_vm._v("Tweets by OSIRIS_CES")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "center col-xs-12 col-sm-12 col-md-9 col-lg-9"
  }, [_c('div', {
    staticClass: "pagetitle"
  }, [_vm._v("\n        " + _vm._s(_vm.content.id_pagina === '17648' ? '' : _vm.content.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "center-content"
  }, [(_vm.legislacao) ? _c('iframe', {
    staticClass: "legislacao",
    attrs: {
      "src": "https://www.ces.uc.pt/osiris/site/api.php/17643/1/get-legislacao"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.content)
    }
  }), _vm._v(" "), _vm._l((_vm.photosets), function(photoset) {
    return _c('div', {
      key: photoset.id
    }, [_c('a', {
      attrs: {
        "data-flickr-embed": "true",
        "data-header": "false",
        "data-footer": "true",
        "href": "https://www.flickr.com/photos/157816548@N08/albums/72157690455141446",
        "title": photoset.title._content
      }
    }, [_c('img', {
      attrs: {
        "src": ("https://farm5.staticflickr.com/" + (photoset.server) + "/" + (photoset.primary) + "_" + (photoset.secret) + ".jpg"),
        "width": "500",
        "height": "375",
        "alt": photoset.title._content
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "photoset-title",
      domProps: {
        "innerHTML": _vm._s(photoset.title._content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "photoset-description",
      domProps: {
        "innerHTML": _vm._s(photoset.description._content)
      }
    })])
  }), _vm._v(" "), (_vm.prj) ? _c('div', {
    staticClass: "project"
  }, [_c('div', {
    staticClass: "project-title"
  }, [(_vm.prj.acronimo) ? _c('span', [_vm._v(" " + _vm._s(_vm.prj.acronimo) + " - ")]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.prj.titulo) + "\n          ")]), _vm._v(" "), (_vm.prj.data_ext) ? _c('div', {
    staticClass: "project-periodo"
  }, [_vm._v("Período "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prj.data_ext))])]) : _vm._e(), _vm._v(" "), (_vm.prj.duracao) ? _c('div', {
    staticClass: "project-duracao"
  }, [_vm._v(" Duração "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.prj.duracao) + " meses")])]) : _vm._e(), _vm._v(" "), (_vm.prj.resumo) ? _c('div', {
    staticClass: "project-resumo"
  }, [_vm._v(" Resumo\n            "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prj.resumo)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.prj.resultados) ? _c('div', {
    staticClass: "project-resultados"
  }, [_vm._v(" Resultados\n            "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prj.resultados)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "project-funding"
  }, [_vm._v("\n            Financiamento:\n          ")]), _vm._v(" "), _c('ul', [_c('li', _vm._l((_vm.prj.instituicoes), function(institution, idx) {
    return _c('span', {
      key: idx
    }, [_c('span', [_vm._v(_vm._s(institution.nome))]), (idx < _vm.prj.instituicoes.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  }))]), _vm._v(" "), (_vm.prj.parceiros) ? _c('div', {
    staticClass: "project-parceiros"
  }, [_vm._v(" Parceiros\n            "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.prj.parceiros)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "project-people"
  }, [_vm._v("\n            Investigadoras/es:\n          ")]), _vm._v(" "), _c('ul', [_c('li', _vm._l((_vm.prj.pessoas), function(person, idx) {
    return _c('span', {
      key: idx
    }, [(person.url) ? _c('span', [_c('a', {
      attrs: {
        "href": person.url
      }
    }, [_vm._v(_vm._s(person.assinatura))])]) : _vm._e(), (!person.url) ? _c('span', [_vm._v(_vm._s(person.assinatura))]) : _vm._e(), _c('br')])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "project-keywords"
  }, [_vm._v("\n            Palavras-chave:\n          ")]), _vm._v(" "), _c('ul', [_c('li', _vm._l((_vm.prj.palavras), function(palavra, idx) {
    return _c('span', {
      key: idx
    }, [_c('span', [_vm._v(_vm._s(palavra.palavra))]), (idx < _vm.prj.palavras.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.projects), function(ano, index) {
    return _c('div', {
      key: index,
      staticClass: "projects"
    }, [_c('div', [_c('div', {
      staticClass: "ano"
    }, [(ano.key === '0') ? _c('span', [_vm._v("\n                Projectos em Curso\n              ")]) : _vm._e(), _vm._v(" "), (ano.key > 0) ? _c('span', [_vm._v("\n                Concluídos em " + _vm._s(ano.key) + "\n              ")]) : _vm._e()]), _vm._v(" "), _vm._l((ano.value), function(prj, index) {
      return _c('div', {
        key: index,
        staticClass: "projects"
      }, [(!prj.data_ext) ? _c('div', [_c('div', {
        staticClass: "projects-title"
      }, [(prj.acronimo) ? _c('span', [_vm._v(" " + _vm._s(prj.acronimo) + " - ")]) : _vm._e(), _vm._v("\n                  " + _vm._s(prj.titulo) + "\n                ")]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(prj.resumo)
        }
      })]) : _c('div', [_c('div', {
        staticClass: "projects-title"
      }, [_c('a', {
        attrs: {
          "href": '?prj=' + prj.id_projecto
        }
      }, [(prj.acronimo) ? _c('span', [_vm._v(" " + _vm._s(prj.acronimo) + " - ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(prj.titulo) + "\n                  ")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._m(1, true), _vm._v(" "), _c('ul', [_c('li', _vm._l((prj.pessoas), function(person, idx) {
        return _c('span', {
          key: idx
        }, [(person.url) ? _c('span', [_c('a', {
          attrs: {
            "href": person.url
          }
        }, [_vm._v(_vm._s(person.assinatura))])]) : _vm._e(), (!person.url) ? _c('span', [_vm._v(_vm._s(person.assinatura))]) : _vm._e(), (idx < prj.pessoas.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
      }))])]), _vm._v(" "), _c('li', [_vm._m(2, true), _vm._v(" "), _c('ul', [_c('li', _vm._l((prj.instituicoes), function(institution, idx) {
        return _c('span', {
          key: idx
        }, [_c('span', [_vm._v(_vm._s(institution.nome))]), (idx < prj.instituicoes.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
      }))])]), _vm._v(" "), _c('li', [_vm._m(3, true), _vm._v(" "), _c('ul', [_c('li', [_c('span', [_vm._v(_vm._s(prj.data_ext))])])])]), _vm._v(" "), _c('li', [_vm._m(4, true), _vm._v(" "), _c('ul', [_c('li', _vm._l((prj.palavras), function(palavra, idx) {
        return _c('span', {
          key: idx
        }, [_c('span', [_vm._v(_vm._s(palavra.palavra))]), (idx < prj.palavras.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
      }))])])])])])
    })], 2)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "rightbar col-xs-12 col-sm-12 col-md-3 col-lg-3"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.secondary_menu)
    }
  }), _vm._v(" "), (_vm.content.id_pagina === '17648') ? _c('carousel', {
    staticClass: "carousel",
    attrs: {
      "perPage": 1,
      "autoplay": true
    }
  }, _vm._l((_vm.galeriaDestaques), function(destaque) {
    return _c('slide', {
      key: destaque.id_pagina
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(destaque.texto)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-titulo"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(destaque.item_menu)
      }
    }), _vm._v(" "), (destaque.item_menu !== destaque.titulo) ? _c('span', {
      staticClass: "carousel-subtitulo",
      domProps: {
        "innerHTML": _vm._s(destaque.titulo)
      }
    }) : _vm._e()])])
  })) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fb-page",
    attrs: {
      "data-href": "https://www.facebook.com/observatoriodorisco/",
      "data-tabs": "timeline",
      "data-width": "",
      "data-height": "",
      "data-small-header": "false",
      "data-adapt-container-width": "true",
      "data-hide-cover": "false",
      "data-show-facepile": "true"
    }
  }, [_c('blockquote', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "cite": "https://www.facebook.com/observatoriodorisco/"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/observatoriodorisco/"
    }
  }, [_vm._v("OSIRIS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-people"
  }, [_c('strong', [_vm._v("Investigadoras/es:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-funding"
  }, [_c('strong', [_vm._v("Financiamento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-time"
  }, [_c('strong', [_vm._v("Período:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-keywords"
  }, [_c('strong', [_vm._v("Palavras-chave:")])])
}]}

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container container-fluid",
    attrs: {
      "id": "main-container"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row main-content row-lg-eq-height"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row outside-content row-lg-eq-height"
  }, [_c('marquee', [_vm._l((_vm.sigimera), function(sig) {
    return _c('a', {
      key: sig._id,
      attrs: {
        "href": sig.rdfs_seeAlso
      }
    }, [_vm._v("\n            " + _vm._s(sig.dc_title) + "   | \n          ")])
  }), _vm._v(" "), _vm._l((_vm.hResponse), function(hr) {
    return _c('a', {
      key: hr.id,
      attrs: {
        "href": hr.id
      }
    }, [_vm._v("\n            " + _vm._s(hr.label) + "   | \n          ")])
  }), _vm._v(" "), _vm._l((_vm.reliefWeb), function(rw) {
    return _c('a', {
      key: rw.id,
      attrs: {
        "href": rw.href
      }
    }, [_vm._v("\n            " + _vm._s(rw.fields.name) + "   | \n          ")])
  })], 2)], 1), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header-content row-lg-eq-height"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/osiris/static/img/logo_osiris_cores.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-ces",
    attrs: {
      "src": "/osiris/static/img/logo_ces.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row footer-content row-lg-eq-height"
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-left"
  }, [_c('strong', [_vm._v("Observatório do Risco OSIRIS")]), _c('br'), _vm._v("\n            Centro de Estudos Sociais (CES)"), _c('br'), _vm._v("\n            Universidade de Coimbra"), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_vm._v("\n            Colégio de S. Jerónimo"), _c('br'), _vm._v("\n            Apartado 3087"), _c('br'), _vm._v("\n            3001-401 Coimbra"), _c('br'), _vm._v("\n            PORTUGAL"), _c('br'), _vm._v("\n            Telefone: +351239855590"), _c('br'), _vm._v("\n            E-mail: osiris@ces.uc.pt"), _c('br'), _vm._v("\n            www.ces.uc.pt/osiris\n          ")])])])
}]}

/***/ })

},[45]);


// WEBPACK FOOTER //
// static/js/app.337cc8db3b3bff0481ca.js